module.exports = __webpack_public_path__ + "media/images/WHATSAPP_img_crop-851661d999a1527ee7c43f9b45a7f9aa.png";